import Styles from './Layout.module.scss';

const Body = ({ children, ...props }) => {
  return <div className={Styles.body}>{children}</div>;
};

export default Body;
